require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-writing-product-descriptions-that-sell.json") })
        }
      }, "path---tapd-in-writing-product-descriptions-that-sell");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-writing-product-descriptions-that-sell!./.cache/json/tapd-in-writing-product-descriptions-that-sell.json
// module id = 888
// module chunks = 231608221292675